import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardApprovalsRoutes = [
	{
		key: "reward-approvals-return",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/approvals/return`,
		component: React.lazy(() => import("views/reward-views/approvals/return/pages/ReturnApprovalsList")),
	},
	{
		key: "reward-approvals-return-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/approvals/return/:id`,
		component: React.lazy(() => import("views/reward-views/approvals/return/pages/ReturnInfo")),
	},
	{
		key: "reward-approvals-discount",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/approvals/discounts`,
		component: React.lazy(() => import("views/reward-views/approvals/discount/pages/DiscountApprovalsList")),
	},
	{
		key: "reward-approvals-discount-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/approvals/discounts/:id`,
		component: React.lazy(() => import("views/reward-views/approvals/discount/pages/DiscountInfo")),
	},
];
